import React from "react";
import main from "../assets/images/main.png";
import { FaPhone, FaEnvelope, FaTty, FaMapMarkerAlt } from "react-icons/fa";
import { Link } from "react-router-dom";

const footerstyles = {
  border: "0px",
  marginBottom: "1.5em",
  margin: "0 auto",
};
const fontstyles = {
  fontSize: ".95em",
  background: "#02223D",
};

const border = {
  borderBottom: "1px solid red",
  width: "max-content",
};
const Footer = () => {
  return (
    <footer
      className="container-fluid d-flex mx-md-auto px-md-5 pt-5 pb-1"
      style={fontstyles}
    >
      <div className="row p-1 footer-content text-center justify-content-md-around justify-content-center">
        <div className="col-4 col-md-2  m-md-1 m-lg-0  ">
          <h5 style={border} className="text-nowrap footerlinks">
            Quick Links
          </h5>
          <ul className="list-unstyled  p-1 text-start text-small ">
            <li>
              <Link className=" text-white text-decoration-none" to="/">
                Home
              </Link>
            </li>
            <li>
              <Link className=" text-white text-decoration-none" to="/about">
                About
              </Link>
            </li>
            <li>
              <Link className=" text-white text-decoration-none" to="/services">
                Services
              </Link>
            </li>
            <li>
              <Link className=" text-white text-decoration-none" to="/careers">
                Careers
              </Link>
            </li>
            {/*<li>
              <Link className=" text-white text-decoration-none" to="/contact">
                ContactUs
              </Link>
            </li> */}
          </ul>
        </div>

        <div className="col-8 col-md-3 m-lg-0 m-md-2  contactfooter">
          <h5 style={border} className="footerlinks">
            Contact Us
          </h5>
          <ul className="list-unstyled text-start text-white ">
            <li>
              <Link className=" text-white" to="#">
                <FaEnvelope className="m-1 m-md-2" />
                info@vibgyoradvisors.com
              </Link>
            </li>
            <li className=" text-white">
              <FaPhone className="m-1 m-md-2" />
              8591402580
            </li>
            <li className=" text-white">
              <FaTty className="m-md-2 m-1" />
              +912240122167
            </li>
          </ul>
        </div>
        <div className="col-9 col-md-3  m-2 m-lg-0  m-md-2">
          <h5 style={border} className="footerlinks ">
            Locate Us
          </h5>
          <p className=" text-white text-start">
            <FaMapMarkerAlt className="m-1" />
            Vibgyor Advicorp Private Limited, <br /> 202, Shivai Industrial
            Estate, <br />
            Saki Naka, <br /> Andheri (E) , <br /> Mumbai 400072.
          </p>
        </div>

        <div className="col-12 col-md-12 col-lg-3 p-3 mt-0 pt-0 m-3 m-md-0 ">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d942.509209536314!2d72.88495924662655!3d19.106039787477968!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x13327f48a2d2f09f!2sVibgyor%20Advisors!5e0!3m2!1sen!2sin!4v1631642054466!5m2!1sen!2sin"
            width="350px"
            height="200px"
            style={footerstyles}
            allowfullscreen=""
            loading="lazy"
          ></iframe>
        </div>
      </div>
    </footer>
    // <footer className="site-footer">
    // <div className="container">
    // <div className="row">
    // <div className="col-sm-12 col-md-4">
    // <h6>Locate Us</h6>
    // <ul className="footer-links">
    // <li><i className="fas fa-map-marker-alt"></i>&emsp;Vibgyor Advicorp Private Limited, 117, Swastik Disa Corporate Park, Opp Shreyas Cinema, LBS Marg, Ghatkopar (W), Mumbai 400086.</li>
    // <li>
    // <div className="map"> </div>
    // </li>
    // </ul>
    // </div>
    // <div className="col-sm-12 col-md-4">
    // <h6>Connect Us</h6>
    // <ul className="footer-links">
    // <li><i className="fas fa-envelope"></i>

    // &emsp;info@vibgyoradvisors.com

    // </li>

    // <li><i className="fas fa-phone"></i>&emsp;8591402580</li>
    // <li><i className="fas fa-tty"></i>&emsp;022-79615327</li>
    // </ul>
    // </div>
    // <div className="col-sm-12 col-md-4">
    // <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4483.712803053567!2d72.91082386943492!3d19.09282140785004!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c7cc36cfdd89%3A0x108837ab2c1bc1f!2sSwastik%20Disa%20Corporate%20Park!5e0!3m2!1sen!2sin!4v1620983347252!5m2!1sen!2sin" width="350" height="200" style={footerstyles} allowfullscreen="" loading="lazy" data-darkreader-inline-border-top="" data-darkreader-inline-border-right="" data-darkreader-inline-border-bottom="" data-darkreader-inline-border-left=""></iframe>
    // <div className="col-12 col-md-2 m-3 m-lg-0">
    //   <img src={main} alt="vibgyor logo" height="70" width="80"/>
    //   <small className="d-block mb-3 ml-2  text-white">&copy;2019</small>
    // </div>

    // </div>
    // </div>
    // <hr/>
    // </div>
    // <div className="container">
    // <div className="row">
    // <div className="col-md-8 col-sm-6 col-xs-12">
    // <p className="copyright-text">Division of Vibgyor Advicorp PVT Limited © 2019
    // </p>
    // </div>
    // <div className="col-md-4 col-sm-6 col-xs-12">
    // <ul className="social-icons">
    // <li><Link  className="facebook" to="https://m.facebook.com/Vibgyor-Advisors-100787492108783/"><i className="fab fa-facebook-f"></i></Link></li>
    // <li><Link  className="twitter" to="https://twitter.com/AdvisorsVibgyor"><i className="fab fa-twitter"></i></Link></li>
    // <li><Link  className="dribbble" to="https://www.instagram.com/vibgyor_advisors/"><i className="fab fa-instagram"></i></Link></li>
    // <li><Link  className="linkedin" to="https://www.linkedin.com/company/vibgyor-advisors/"><i className="fab fa-linkedin"></i></Link></li>
    // </ul>
    // </div>
    // </div>
    // </div>
    // </footer>
  );
};

export default Footer;
